import React from 'react';
import { EditorActions } from 'app/stores/editor/actions';
import { hasSelectedUnlockedMarkers } from 'app/stores/selectors';
import { useAppDispatch } from 'app/stores/store';
import { useConnect } from 'app/views/hooks/useConnect';
import { addDoubleTapListener } from 'app/utils/events';
import { noop } from 'app/utils/function';
export const useTextEditor = () => {
    const [node, setNode] = React.useState(null);
    const dispatch = useAppDispatch();
    const stateProps = useConnect(state => {
        const hasEditableTextItemSelected = hasSelectedUnlockedMarkers(state, 1, 'Text');
        return {
            activeTool: state.editor.activeTool,
            hasTextItemSelected: hasEditableTextItemSelected,
        };
    });
    const { activeTool, hasTextItemSelected } = stateProps;
    const onDoubleClick = React.useCallback(() => {
        dispatch(EditorActions.editText({}));
    }, [dispatch]);
    const onKeyDown = React.useCallback((evt) => {
        const { key, metaKey, shiftKey, altKey, ctrlKey } = evt;
        const anyModKey = metaKey || shiftKey || altKey || ctrlKey;
        if (!anyModKey &&
            /^[a-zA-Z0-9\-*!@#$%^&*(){}[\]<>\n\s+\\/]{1}$/.test(key)) {
            dispatch(EditorActions.editText({ textToAppend: key }));
        }
    }, [dispatch]);
    // -----------------------
    // Text entering
    // -----------------------
    React.useEffect(() => {
        if (!hasTextItemSelected) {
            return noop;
        }
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [hasTextItemSelected, onKeyDown]);
    // -----------------------
    // Double click
    // -----------------------
    React.useEffect(() => {
        if (!node || !hasTextItemSelected) {
            return noop;
        }
        const logger = getLogger('HandleDrag', 'debug');
        logger('[Mouse][Register] useTextEditor');
        const disposer = addDoubleTapListener(node, onDoubleClick);
        const unsubscribe = () => {
            logger('[Mouse][Unregister] useTextEditor');
            disposer();
        };
        return unsubscribe;
    }, [node, activeTool, hasTextItemSelected, onDoubleClick]);
    return [setNode];
};
